module.exports = __webpack_public_path__ + "img/game_3.61f6ea1a.jpg";